import { Pencil } from "helper/images";
import { add } from "helper/icons";
import { globalVariables } from "helper/globalVariables";
import { OutlineButton } from "shared/Components/outlineButton";

export default function Notes({ text, onClick, customHeight }) {
  return (
    <div
      className={`rounded-xl bg-white p-4 flex gap-2 flex-col ${customHeight}`}
    >
      <div className="flex flex-row gap-2 justify-between items-center">
        <div className="flex flex-row gap-2 items-baseline">
          <span className="text-xl font-bold">{globalVariables.note}:</span>
          <Pencil onClick={onClick} className="h-5 w-5" />
        </div>
        {/* <OutlineButton
          width={"w-[150px]"}
          icon={add}
          label={
            text === "" ? globalVariables.addNote : globalVariables.updateNote
          }
          
        /> */}
      </div>
      <div>
        {text === "" ? (
          <span className="text-sm text-gray-600">No Notes Added</span>
        ) : (
          <span className="text-sm">{text}</span>
        )}
      </div>
    </div>
  );
}
